import React, { useEffect, useState } from "react";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import ProcedureOutcomeClient from "../../api-services/coders/procedure-outcome/procedure-client";
import { useTranslation } from "react-i18next";
import Joi from "joi-browser";
import {
  handleSave,
  validateForm,
  serverValidation,
} from "../../../common/validation/validation";
import Moment from "moment";

const CreateProcedureOutcome = ({ row, handleCallback, isCreate }) => {
  const [procedureOutcome, setProcedureOutcome] = useState({
    id: 0,
    name: "",
    weight: 0,
    isActive: true,
    userFullName: "",
    lastModifyDate: null,
  });

  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const schema = {
    name: Joi.string().required(),
    weight: Joi.number().min(0).max(2147483647).required(),
  };

  const client = new ProcedureOutcomeClient();
  useEffect(() => {
    setProcedureOutcome(row);
    setErrors({});
  }, [row, isCreate]);

  const CreateProcedureOutcome = async () => {
    const errorsResult = validateForm(procedureOutcome, schema, t);
    setErrors(errorsResult);

    if (!errorsResult) {
      const data = {
        ...procedureOutcome,
        weight: parseInt(procedureOutcome.weight),
        lastModifyDate: new Date(),
      };
      var response = await client.CreateProcedureOutcome(data);
      var handledResponse = HandlingResponse(response);
      if (handledResponse.code == 408) {
        var result = serverValidation(handledResponse.data, t);
        setErrors(result);
      } else handleCallback(handledResponse);
    }
  };

  const UpdateProcedureOutcome = async () => {
    const errorsResult = validateForm(procedureOutcome, schema, t);
    setErrors(errorsResult);

    if (!errorsResult) {
      const data = {
        ...procedureOutcome,
        weight: parseInt(procedureOutcome.weight),
        lastModifyDate: new Date(),
      };

      var response = await client.UpdateProcedureOutcome(
        procedureOutcome.id,
        data
      );
      var handledResponse = HandlingResponse(response);
      if (handledResponse.code == 408) {
        var result = serverValidation(handledResponse.data, t);
        setErrors(result);
      } else handleCallback(handledResponse);
    }
  };

  const handlePropertyChange = (event, date) => {
    const obj = date
      ? { name: date, value: event }
      : { name: event.name, value: event.value };
    const result = handleSave(obj, procedureOutcome, errors, schema, t);
    setProcedureOutcome(result.data);
    setErrors(result.errors);
  };

  return (
    <>
      <form>
        <div className="form-group">
          <label>Назив<span className="required-asterisk">*</span></label>
          <input
            className="form-control"
            type="text"
            name="name"
            value={procedureOutcome.name}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.name && <div className="text-danger">{errors.name}</div>}
        </div>
        <div className="form-group">
          <label>Тежина<span className="required-asterisk">*</span></label>
          <input
            className="form-control"
            type="number"
            name="weight"
            value={procedureOutcome.weight}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.weight && <div className="text-danger">{errors.weight}</div>}
        </div>
        <div>
        <input
                id="activeProcedureOutcomeCB"
                    type="checkbox"
                    value={procedureOutcome.isActive}
                    checked={procedureOutcome.isActive}
                    onChange={(event) => {
                        setProcedureOutcome({ ...procedureOutcome, isActive: event.target.checked });
                    }}
          />
          <label htmlFor="activeProcedureOutcomeCB">Активан</label>
        </div>
        {!isCreate ? (
          <>
            <div className="form-group">
              <label>Идентификатор</label>
              <div>{procedureOutcome.id}</div>
            </div>
            <div className="form-group">
              <label>Корисник</label>
              <div>{procedureOutcome.userFullName}</div>
            </div>
            <div className="form-group">
              <label>Датум и време последње измене</label>
              <div>
                {Moment(procedureOutcome.lastModifyDate).format("DD.MM.YYYY.")}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="text-right">
          {isCreate ? (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => CreateProcedureOutcome()}
            >
              Сачувај
            </button>
          ) : (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => UpdateProcedureOutcome()}
            >
              Сачувај измене
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default CreateProcedureOutcome;
